import html from "./main.component.html";
import css from "./main.component.css";
import {
    Click,
    WebzComponent,
    WebzDialog,
    BindCheckedToBoolean,
    BindVisibleToBoolean,
} from "@boots-edu/webz";
import { GridComponent } from "./grid/grid.component";

/**
 * @description MainComponent is the main component of the app
 * @extends WebzComponent
 *
 */
export class MainComponent extends WebzComponent {
    private board: GridComponent;
    @BindCheckedToBoolean("easy")
    @BindVisibleToBoolean("replay")
    private easy: boolean = false;

    constructor() {
        super(html, css);
        const grid = new GridComponent();

        this.addComponent(grid, "board");
        this.board = grid;

        this.board.spreadDeck();
        this.rulesShow();
    }
    /**
     * Broadcasts easy mode (all boards generate with a possible solution, unlimited undos, replay button option)
     */
    @Click("easy")
    easyMode() {
        WebzDialog.popup(
            this,
            "This will reset your game. Would you like to proceed?",
            "Warning",
            ["Yes", "Cancel"],
        ).subscribe((value: string) => {
            if (value === "Yes") {
                this.easy = !this.easy;
                this.board.setEasy(this.easy);
            }
            this.easy = this.easy!; // checkbox won't uncheck otherwise... I hope there is a better solution
            console.log("Easy mode: " + this.easy);
        });
    }

    /**
     * Displays the rules popup at the start of the game and whenever the rules button is clicked
     */
    @Click("rules")
    rulesShow() {
        WebzDialog.popup(
            this,
            "The goal of the game is to organize all cards in descending order with kings on the left. You may only move cards to empty spots such that the preceeding card (to the left) is the same suit and one rank above. Thus spots after twos and blank spaces are virtually dead (until the 2 is moved). The game ends when all spots are dead and no cards can be moved. For your convenience I have added a highlight feature to assist your understanding of your possible moves. Cards highlighted in green may be swapped immediately, but if the card is red there is at least a step in your way of moving the card there.",
            "Rules",
        );
    }
    /**
     * Triggers the undo method on the border when the button is clicked
     */
    @Click("undo")
    undoLast() {
        this.board.undo();
    }

    @Click("replay")
    replayBoard() {
        this.board.replay();
    }
}
